import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=2c996d83&scoped=true&"
import script from "./ForgotPassword.js?vue&type=script&lang=js&"
export * from "./ForgotPassword.js?vue&type=script&lang=js&"
import style0 from "./ForgotCredentials.scss?vue&type=style&index=0&id=2c996d83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c996d83",
  null
  
)

export default component.exports